import { useAuth as useAuthContext } from '../contexts/AuthContext';

// Re-export the AuthContext hook for backward compatibility
export const useAuth = useAuthContext;

export default useAuth;
